<template>
    <q-page class="q-pa-md">

        <q-dialog class="rounded-borders" v-model="dialogDetalles" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Detalles del Vehiculo</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-stepper v-model="step" ref="stepper" header-nav bordered color="primary" animated
                        class="shadow-0">
                        <!-- INFORMACION DEL CLIENTE Y DE SUS DOCUMENTOS -->
                        <q-step :name="1" title="Vehiculo" icon="settings" :done="done1">
                            <q-card class="shadow-0">
                                <q-card-section class="row items-center q-pb-none">
                                    <div class="text-h6">Datos Generales del Vehiculo</div>
                                </q-card-section>
                                <q-separator class="q-mt-md" />
                                <q-card-section>
                                    <div class="row q-col-gutter-sm">
                                        <div class="col-12 col-md-12" v-if="nuevoAuto">
                                            <q-select dense outlined v-model="selectAgencia" :options="listaAgencias"
                                                label="Agencia" color="primary" option-label="razon_social" clearable
                                                options-selected-class="text-deep-blue">
                                                <template v-slot:option="scope">
                                                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                        <q-item-section avatar>
                                                            <q-icon name="mdi-car" color="priamry" />
                                                        </q-item-section>
                                                        <q-item-section>
                                                            <q-item-label
                                                                v-html="scope.opt.rfc + ' - ' + scope.opt.razon_social" />
                                                            <q-item-label caption>{{ scope.opt.representante
                                                            }}</q-item-label>
                                                        </q-item-section>
                                                    </q-item>
                                                </template>
                                            </q-select>
                                        </div>
                                        <div class="col-12 col-md-12" v-if="!nuevoAuto">
                                            <q-input v-model="auto.agencia" outlined label="Agencia" dense required
                                                readonly />
                                        </div>
                                        <div class="col-12 col-md-12" v-if="nuevoAuto">
                                            <q-select outlined v-model="selectModelo" :options="itemsModelos"
                                                label="Modelo del Vehiculo" option-label="modelo" dense required
                                                emit-value map-options>
                                                <template v-slot:option="scope">
                                                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                        <q-item-section avatar>
                                                            <q-icon name="mdi-car" color="priamry" />
                                                        </q-item-section>
                                                        <q-item-section>
                                                            <q-item-label
                                                                v-html="scope.opt.marca + ' ' + scope.opt.modelo + ' ' + scope.opt.version" />
                                                            <q-item-label caption>{{ scope.opt.tipovehiculo + ', ' +
                                                                scope.opt.anio + ', ' + scope.opt.color
                                                                }}</q-item-label>
                                                        </q-item-section>
                                                    </q-item>
                                                </template>
                                            </q-select>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input v-model="selectModelo.marca" outlined label="Nombre de marca" dense
                                                required readonly />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input v-model="selectModelo.modelo" outlined label="Modelo" dense
                                                required readonly />
                                        </div>

                                        <div class="col-12 col-md-4">
                                            <q-input v-model="selectModelo.version" outlined label="Version" dense
                                                required readonly />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input v-model="selectModelo.tipovehiculo" outlined
                                                label="Tipo de Vehiculo" dense required readonly />
                                        </div>
                                        <!-- <div class="col-12 col-md-4">
                                            <q-input outlined label="Precio" dense required />
                                        </div> -->
                                        <div class="col-12 col-md-4">
                                            <q-input v-model="selectModelo.anio" outlined label="Año" dense required
                                                readonly />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input v-model="selectModelo.color" outlined label="Color" dense required
                                                readonly />
                                        </div>
                                    </div>
                                </q-card-section>
                                <q-separator class="q-mt-md" />
                                <q-card-section>
                                    <div class="row q-col-gutter-sm">
                                        <div class="col-12 col-md-3">
                                            <q-input v-model="auto.numeroserie" outlined label="Número de Serie" dense
                                                required />
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <q-input v-model="auto.numeromotor" outlined label="Número de Motor" dense
                                                required />
                                        </div>

                                        <div class="col-12 col-md-3">
                                            <q-input v-model="auto.placa" outlined label="Placa" dense required />
                                        </div>

                                        <div class="col-12 col-md-3">
                                            <q-input v-model="auto.permiso" outlined label="Núm. Permiso" dense
                                                required />
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <q-input v-model="auto.estadoplaca" outlined label="Estado (Origen)" dense
                                                required />
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <q-input class="q-ma-none q-pa-none" dense outlined
                                                v-model="auto.fechaadquisicion" label="Fecha de Adquisición" mask="date"
                                                bottom-slots placeholder="yyyy/MM/dd">
                                                <template v-slot:after>
                                                    <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                                        <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy"
                                                            transition-show="scale" transition-hide="scale">
                                                            <q-date class="q-ma-none q-pa-none"
                                                                v-model="auto.fechaadquisicion">
                                                                <div
                                                                    class="row items-center justify-end q-ma-none q-pa-none">
                                                                    <q-btn v-close-popup label="Ok" color="primary"
                                                                        class="q-ma-none q-pa-none" flat />
                                                                </div>
                                                            </q-date>
                                                        </q-popup-proxy>
                                                    </q-icon>
                                                </template>
                                            </q-input>
                                        </div>
                                        <div class="col-12 col-md-12">
                                            <q-input v-model="auto.beneficionproveedor" outlined label="Notas" dense
                                                required />
                                        </div>
                                    </div>
                                </q-card-section>
                                <q-card-actions v-if="nuevoAuto">
                                    <q-btn flat color="red" label="Cerrar" v-close-popup />
                                    <q-space />
                                    <q-btn @click="PostAuto()" flat color="primary" label="Guardar" />
                                </q-card-actions>
                            </q-card>
                        </q-step>

                        <!-- INFORMACION DEL VEHICULO -->
                        <q-step :name="2" title="Seguros" icon="create_new_folder" :done="done2">
                            <q-card class="shadow-0">
                                <q-card-section>
                                    <q-table hide-bottom dense title="Seguros" class="shadow-0" :data="items"
                                        :loading="loading" :columns="columnsSeguros" color="primary" row-key="_id">
                                        <template v-slot:body="props">
                                            <q-tr :props="props" class="hover-fila">
                                                <q-td key="compania" :props="props" @click="verItem(props.row)">{{
                                                    props.row.compania
                                                    }}</q-td>
                                                <q-td key="poliza" :props="props" @click="verItem(props.row)">{{
                                                    props.row.poliza }}</q-td>
                                                <q-td key="tipo" :props="props" @click="verItem(props.row)">{{
                                                    props.row.tipo }}</q-td>
                                                <q-td key="fechaemision" :props="props"
                                                    @click="verItem(formatearFecha(props.row))">{{
                                                        props.row.fechaemision }}</q-td>
                                                <q-td key="finicio" :props="props" @click="verItem(props.row)">{{
                                                    formatearFecha(props.row.finicio) }}</q-td>
                                                <q-td key="fvencimiento" :props="props" @click="verItem(props.row)">{{
                                                    formatearFecha(props.row.fvencimiento)
                                                    }}</q-td>
                                                <q-td key="formapago" :props="props" @click="verItem(props.row)">{{
                                                    props.row.formapago
                                                    }}</q-td>
                                                <q-td key="costototal" :props="props" @click="verItem(props.row)">{{
                                                    formatoMonedaMexicana(props.row.costototal)
                                                    }}</q-td>
                                                <q-td key="estado" :props="props" @click="verItem(props.row)">
                                                    <q-badge v-if="props.row.estado == 'activo'" color="green"
                                                        label="Activo" />
                                                    <q-badge v-if="props.row.estado == 'inactivo'" color="orange"
                                                        label="Inactivo" />
                                                </q-td>
                                            </q-tr>
                                        </template>
                                    </q-table>
                                </q-card-section>
                            </q-card>
                        </q-step>

                        <q-step :name="3" title="Pagos" icon="create_new_folder" :done="done3">
                            <q-card class="shadow-0">
                                <q-list bordered>
                                    <q-expansion-item popup bordered group="somegroup" icon="mdi-account-cash"
                                        label="Pagos de Seguros" default-opened header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <q-table dense class="shadow-0" :data="dataListSeguro"
                                                    :columns="columnsPagos" color="primary" row-key="_id" hide-bottom
                                                    :rows-per-page-options="[0]" :virtual-scroll-item-size="48"
                                                    :table-colspan="9" style="max-height: 300px" virtual-scroll
                                                    ref="table">
                                                    <template v-slot:body="props">
                                                        <q-tr :props="props">
                                                            <q-td key="nombre" :props="props">{{ props.row.nombre
                                                                }}</q-td>
                                                            <q-td key="concepto" :props="props">{{ props.row.concepto
                                                                }}</q-td>
                                                            <q-td key="monto" :props="props">{{
                                                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                                                            <q-td key="tipo" :props="props">{{ props.row.tipo ?
                                                                props.row.tipo.toUpperCase() : ''
                                                                }}</q-td>
                                                            <q-td key="fechacreacion" :props="props">{{
                                                                formatearFecha(props.row.fechacreacion) }}</q-td>
                                                            <q-td key="fechamaximapago" :props="props">{{
                                                                formatearFecha(props.row.fechamaximapago) }}</q-td>
                                                            <q-td key="estado" :props="props">
                                                                <q-badge v-if="props.row.estado == 'XP'" color="orange"
                                                                    label="Cuenta por Pagar" />
                                                                <q-badge v-if="props.row.estado == 'V'" color="purple"
                                                                    label="Pendiente de Validar" />
                                                                <q-badge v-if="props.row.estado == 'P'" color="green"
                                                                    label="Pagado" />
                                                            </q-td>
                                                        </q-tr>
                                                    </template>
                                                </q-table>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-expansion-item popup bordered group="somegroup" icon="mdi-account-cash"
                                        label="Pagos de Multas" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <q-table dense class="shadow-0" :data="dataListMultas"
                                                    :columns="columnsPagos" color="primary" row-key="_id" hide-bottom>
                                                    <template v-slot:body="props">
                                                        <q-tr :props="props">
                                                            <q-td key="nombre" :props="props">{{ props.row.nombre
                                                                }}</q-td>
                                                            <q-td key="concepto" :props="props">{{ props.row.concepto
                                                                }}</q-td>
                                                            <q-td key="monto" :props="props">{{
                                                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                                                            <q-td key="tipo" :props="props">{{ props.row.tipo ?
                                                                props.row.tipo.toUpperCase() : ''
                                                                }}</q-td>
                                                            <q-td key="fechacreacion" :props="props">{{
                                                                formatearFecha(props.row.fechacreacion) }}</q-td>
                                                            <q-td key="fechamaximapago" :props="props">{{
                                                                formatearFecha(props.row.fechamaximapago) }}</q-td>
                                                            <q-td key="estado" :props="props">
                                                                <q-badge v-if="props.row.estado == 'XP'" color="orange"
                                                                    label="Cuenta por Pagar" />
                                                                <q-badge v-if="props.row.estado == 'V'" color="purple"
                                                                    label="Pendiente de Validar" />
                                                                <q-badge v-if="props.row.estado == 'P'" color="green"
                                                                    label="Pagado" />
                                                            </q-td>
                                                        </q-tr>
                                                    </template>
                                                </q-table>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-expansion-item popup bordered group="somegroup" icon="mdi-account-cash"
                                        label="Pagos por Tenencia" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <q-table dense class="shadow-0" :data="dataListTenencias"
                                                    :columns="columnsPagos" color="primary" row-key="_id" hide-bottom>
                                                    <template v-slot:body="props">
                                                        <q-tr :props="props">
                                                            <q-td key="nombre" :props="props">{{ props.row.nombre
                                                                }}</q-td>
                                                            <q-td key="concepto" :props="props">{{ props.row.concepto
                                                                }}</q-td>
                                                            <q-td key="monto" :props="props">{{
                                                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                                                            <q-td key="tipo" :props="props">{{ props.row.tipo ?
                                                                props.row.tipo.toUpperCase() : ''
                                                                }}</q-td>
                                                            <q-td key="fechacreacion" :props="props">{{
                                                                formatearFecha(props.row.fechacreacion) }}</q-td>
                                                            <q-td key="fechamaximapago" :props="props">{{
                                                                formatearFecha(props.row.fechamaximapago) }}</q-td>
                                                            <q-td key="estado" :props="props">
                                                                <q-badge v-if="props.row.estado == 'XP'" color="orange"
                                                                    label="Cuenta por Pagar" />
                                                                <q-badge v-if="props.row.estado == 'V'" color="purple"
                                                                    label="Pendiente de Validar" />
                                                                <q-badge v-if="props.row.estado == 'P'" color="green"
                                                                    label="Pagado" />
                                                            </q-td>
                                                        </q-tr>
                                                    </template>
                                                </q-table>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-expansion-item popup bordered group="somegroup" icon="mdi-account-cash"
                                        label="Pagos por Verificación" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <q-table dense class="shadow-0" :data="dataListVerificaciones"
                                                    :columns="columnsPagos" color="primary" row-key="_id" hide-bottom>
                                                    <template v-slot:body="props">
                                                        <q-tr :props="props">
                                                            <q-td key="nombre" :props="props">{{ props.row.nombre
                                                                }}</q-td>
                                                            <q-td key="concepto" :props="props">{{ props.row.concepto
                                                                }}</q-td>
                                                            <q-td key="monto" :props="props">{{
                                                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                                                            <q-td key="tipo" :props="props">{{ props.row.tipo ?
                                                                props.row.tipo.toUpperCase() : ''
                                                                }}</q-td>
                                                            <q-td key="fechacreacion" :props="props">{{
                                                                formatearFecha(props.row.fechacreacion) }}</q-td>
                                                            <q-td key="fechamaximapago" :props="props">{{
                                                                formatearFecha(props.row.fechamaximapago) }}</q-td>
                                                            <q-td key="estado" :props="props">
                                                                <q-badge v-if="props.row.estado == 'XP'" color="orange"
                                                                    label="Cuenta por Pagar" />
                                                                <q-badge v-if="props.row.estado == 'V'" color="purple"
                                                                    label="Pendiente de Validar" />
                                                                <q-badge v-if="props.row.estado == 'P'" color="green"
                                                                    label="Pagado" />
                                                            </q-td>
                                                        </q-tr>
                                                    </template>
                                                </q-table>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-expansion-item popup bordered group="somegroup" icon="mdi-account-cash"
                                        label="Pagos por Corralón" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <q-table dense class="shadow-0" :data="dataListCorralon"
                                                    :columns="columnsPagos" color="primary" row-key="_id" hide-bottom>
                                                    <template v-slot:body="props">
                                                        <q-tr :props="props">
                                                            <q-td key="nombre" :props="props">{{ props.row.nombre
                                                                }}</q-td>
                                                            <q-td key="concepto" :props="props">{{ props.row.concepto
                                                                }}</q-td>
                                                            <q-td key="monto" :props="props">{{
                                                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                                                            <q-td key="tipo" :props="props">{{ props.row.tipo ?
                                                                props.row.tipo.toUpperCase() : ''
                                                                }}</q-td>
                                                            <q-td key="fechacreacion" :props="props">{{
                                                                formatearFecha(props.row.fechacreacion) }}</q-td>
                                                            <q-td key="fechamaximapago" :props="props">{{
                                                                formatearFecha(props.row.fechamaximapago) }}</q-td>
                                                            <q-td key="estado" :props="props">
                                                                <q-badge v-if="props.row.estado == 'XP'" color="orange"
                                                                    label="Cuenta por Pagar" />
                                                                <q-badge v-if="props.row.estado == 'V'" color="purple"
                                                                    label="Pendiente de Validar" />
                                                                <q-badge v-if="props.row.estado == 'P'" color="green"
                                                                    label="Pagado" />
                                                            </q-td>
                                                        </q-tr>
                                                    </template>
                                                </q-table>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-expansion-item popup bordered group="somegroup" icon="mdi-account-cash"
                                        label="Pagos de Grua" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <q-table dense class="shadow-0" :data="dataListGrua"
                                                    :columns="columnsPagos" color="primary" row-key="_id" hide-bottom>
                                                    <template v-slot:body="props">
                                                        <q-tr :props="props">
                                                            <q-td key="nombre" :props="props">{{ props.row.nombre
                                                                }}</q-td>
                                                            <q-td key="concepto" :props="props">{{ props.row.concepto
                                                                }}</q-td>
                                                            <q-td key="monto" :props="props">{{
                                                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                                                            <q-td key="tipo" :props="props">{{ props.row.tipo ?
                                                                props.row.tipo.toUpperCase() : ''
                                                                }}</q-td>
                                                            <q-td key="fechacreacion" :props="props">{{
                                                                formatearFecha(props.row.fechacreacion) }}</q-td>
                                                            <q-td key="fechamaximapago" :props="props">{{
                                                                formatearFecha(props.row.fechamaximapago) }}</q-td>
                                                            <q-td key="estado" :props="props">
                                                                <q-badge v-if="props.row.estado == 'XP'" color="orange"
                                                                    label="Cuenta por Pagar" />
                                                                <q-badge v-if="props.row.estado == 'V'" color="purple"
                                                                    label="Pendiente de Validar" />
                                                                <q-badge v-if="props.row.estado == 'P'" color="green"
                                                                    label="Pagado" />
                                                            </q-td>
                                                        </q-tr>
                                                    </template>
                                                </q-table>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-expansion-item popup bordered group="somegroup" icon="mdi-account-cash"
                                        label="Pagos por Otras Sanciones" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <q-table dense class="shadow-0" :data="dataListOtrasSanciones"
                                                    :columns="columnsPagos" color="primary" row-key="_id" hide-bottom>
                                                    <template v-slot:body="props">
                                                        <q-tr :props="props">
                                                            <q-td key="nombre" :props="props">{{ props.row.nombre
                                                                }}</q-td>
                                                            <q-td key="concepto" :props="props">{{ props.row.concepto
                                                                }}</q-td>
                                                            <q-td key="monto" :props="props">{{
                                                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                                                            <q-td key="tipo" :props="props">{{ props.row.tipo ?
                                                                props.row.tipo.toUpperCase() : ''
                                                                }}</q-td>
                                                            <q-td key="fechacreacion" :props="props">{{
                                                                formatearFecha(props.row.fechacreacion) }}</q-td>
                                                            <q-td key="fechamaximapago" :props="props">{{
                                                                formatearFecha(props.row.fechamaximapago) }}</q-td>
                                                            <q-td key="estado" :props="props">
                                                                <q-badge v-if="props.row.estado == 'XP'" color="orange"
                                                                    label="Cuenta por Pagar" />
                                                                <q-badge v-if="props.row.estado == 'V'" color="purple"
                                                                    label="Pendiente de Validar" />
                                                                <q-badge v-if="props.row.estado == 'P'" color="green"
                                                                    label="Pagado" />
                                                            </q-td>
                                                        </q-tr>
                                                    </template>
                                                </q-table>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                </q-list>
                            </q-card>
                        </q-step>

                        <q-step :name="4" title="Localizador" icon="create_new_folder" :done="done4">
                            <q-card class="shadow-0" v-if="localizador">
                                <q-card-section class="row items-center q-pb-none">
                                    <div class="text-h6">Localizador</div>
                                    <q-space />
                                </q-card-section>
                                <q-separator class="q-mt-md" />
                                <q-card-section class="row items-center q-pb-none q-col-gutter-md ">


                                    <div class="col-12 col-md-6">
                                        <q-input readonly dense v-model="localizador.proveedor" outlined
                                            label="Proveedor" required />
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <q-input readonly dense v-model="localizador.fecha_compra" outlined
                                            label="Fecha de Compra" required />
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <q-input readonly dense v-model="localizador.fecha_instalacion" outlined
                                            label="Fecha de Instalación" required />
                                    </div>

                                    <div class="col-12 col-md-3">
                                        <q-input readonly prefix="$" dense v-model="localizador.costo_adquisicion"
                                            outlined label="Costo de Adquisición" required mask="#.##" fill-mask="0"
                                            reverse-fill-mask input-class="text-right" />
                                    </div>
                                    <div class="col-12 col-md-3">
                                        <q-input readonly prefix="$" dense v-model="localizador.costo_mensual" outlined
                                            label="Costo Mensual" required mask="#.##" fill-mask="0" reverse-fill-mask
                                            input-class="text-right" />
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-input readonly dense v-model="localizador.numero_serie" outlined
                                            label="Número de Serie" required />
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-input readonly dense v-model="localizador.marca" outlined label="Marca"
                                            required />
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-input readonly dense v-model="localizador.modelo" outlined label="Modelo"
                                            required />
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-input readonly dense v-model="localizador.tipo" outlined label="Tipo"
                                            required />
                                    </div>

                                </q-card-section>
                            </q-card>
                        </q-step>
                    </q-stepper>
                </q-card-section>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md">
            <div class=" col-12">
                <q-table dense title="Autos" class="shadow-1" :data="listaCarros" :loading="loading" :columns="columns"
                    color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-btn outline color="primary" icon="mdi-plus" label="Nuevo" @click="NuevoCarro()" no-caps
                            class="q-mr-sm q-my-md" />
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetAutos()" no-caps
                            class=" q-my-md" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="numeroserie" :props="props" @click="verItem(props.row)">{{
                                props.row.numeroserie }}</q-td>
                            <q-td key="numeromotor" :props="props" @click="verItem(props.row)">{{
                                props.row.numeromotor }}</q-td>
                            <q-td key="placa" :props="props" @click="verItem(props.row)">{{
                                props.row.placa }}</q-td>
                            <q-td key="permiso" :props="props" @click="verItem(props.row)">{{
                                props.row.permiso }}</q-td>
                            <q-td key="estadoplaca" :props="props" @click="verItem(props.row)">{{
                                props.row.estadoplaca }}</q-td>
                            <q-td key="estatus" :props="props" @click="verItem(props.row)">
                                <q-badge v-if="props.row.estatus == 'activo'" color="blue" label="EnAlmacen" />
                                <q-badge v-if="props.row.estatus == 'arrendado'" color="green" label="Arrendado" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import moment from 'moment';
export default {
    data() {
        return {
            loading: false,
            listaCarros: [],
            columns: [
                { name: 'numeroserie', label: 'Num. Serie', field: 'numeroserie', align: 'center', sortable: true },
                { name: 'numeromotor', label: 'Num. Motor', field: 'numeromotor', align: 'center', sortable: true },
                { name: 'placa', label: 'Placa', field: 'placa', align: 'center', sortable: true },
                { name: 'permiso', label: 'Num. Permiso', field: 'permiso', align: 'center', sortable: true },
                { name: 'estadoplaca', label: 'Estado (Origen)', field: 'estadoplaca', align: 'center', sortable: true },
                { name: 'estatus', label: 'Estatus', field: 'estatus', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            dialogDetalles: false,
            step: 1,
            mostrarAltaSeguros: false,
            mostrarAltaPagos: false,
            mostrarAltaServicios: false,
            mostrarAltaVerificaciones: false,
            mostrarAltaMultas: false,
            selectModelo: '',

            done1: false,
            done2: false,
            done3: false,
            done4: false,
            done5: false,
            done6: false,

            auto: {
                id_ModeloAnio: '',
                numeroserie: '',
                numeromotor: '',
                placa: '',
                permiso: '',
                estadoplaca: '',
                id_proveedor: '',
                fechaadquisicion: '',
                beneficionproveedor: '',
                agencia: '',
            },
            nuevoAuto: false,
            selectAgencia: null,
            listaAgencias: [],
            id_vehiculo: '',
            dataListCorralon: [],
            dataListGrua: [],
            dataListOtrasSanciones: [],
            dataListMultas: [],
            dataListSeguro: [],
            dataListTenencias: [],
            dataListVerificaciones: [],
            columnsPagos: [
                { name: 'nombre', label: 'Proveedor', field: 'nombre', align: 'center', sortable: true },
                { name: 'concepto', label: 'Concepto', field: 'concepto', align: 'center', sortable: true },
                { name: 'monto', label: 'Monto', field: 'monto', align: 'right', sortable: true },
                { name: 'tipo', label: 'Tipo', field: 'tipo', align: 'center', sortable: true },
                { name: 'fechacreacion', label: 'Fecha', field: 'fechacreacion', align: 'center', sortable: true },
                { name: 'fechamaximapago', label: 'Fecha Maxima De Pago', field: 'fechamaximapago', align: 'center', sortable: true },
                { name: 'estado', label: 'Estatus', field: 'estado', align: 'center', sortable: true },
            ],
            loading: false,
            items: [],
            columnsSeguros: [
                { name: 'compania', label: 'Aseguradora', field: 'compania', align: 'center', sortable: true },
                { name: 'poliza', label: 'Poliza', field: 'poliza', align: 'center', sortable: true },
                { name: 'tipo', label: 'Tipo', field: 'tipo', align: 'center', sortable: true },
                { name: 'fechaemision', label: 'Fecha de Emisión', field: 'fechaemision', align: 'center', sortable: true },
                { name: 'finicio', label: 'Fecha de Inicio', field: 'finicio', align: 'center', sortable: true },
                { name: 'fvencimiento', label: 'Fecha de Vencimiento', field: 'fvencimiento', align: 'center', sortable: true },
                { name: 'formapago', label: 'Forma de Pago', field: 'formapago', align: 'center', sortable: true },
                { name: 'costototal', label: 'Costo Total', field: 'costototal', align: 'center', sortable: true },
                { name: 'estado', label: 'Estado', field: 'estado', align: 'center', sortable: true }
            ],

            localizador: null
        }
    },
    mounted() {
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
        itemsModelos() {
            return this.$store.state.auth.listModelosStore
        }
    },
    created() {
        this.GetAutos();
        this.GetModelos();
        this.GetProveedores();
    },
    methods: {
        async verItem(item) {
            this.nuevoAuto = false
            this.id_vehiculo = item._id
            console.log(item)
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando detalles. Espere...', messageColor: 'white' })

            this.auto = {
                id_ModeloAnio: item.id_ModeloAnio,
                numeroserie: item.numeroserie,
                numeromotor: item.numeromotor,
                placa: item.placa,
                estadoplaca: item.estadoplaca,
                id_proveedor: item.id_proveedor,
                fechaadquisicion: item.fechaadquisicion,
                beneficionproveedor: item.beneficionproveedor,
                agencia: item.agencia,
                permiso: item.permiso,
            }

            this.selectModelo = this.itemsModelos.find(x => x._id == item.id_ModeloAnio)
            this.GetListaSeguros();
            this.GetCxPSeguro();
            this.GetCxPMultas();
            this.GetCxPTenencia();
            this.GetCxPVerificacion();
            this.GetCxPVerificacion();
            this.GetCxPCorralon();
            this.GetCxPGrua();
            this.GetCxPOtrasSanciones();
            this.GetLocalizadorPorAuto();
            this.$q.loading.hide()
            this.dialogDetalles = true

        },
        NuevoCarro() {
            this.auto = {
                id_ModeloAnio: '',
                numeroserie: '',
                numeromotor: '',
                placa: '',
                estadoplaca: '',
                id_proveedor: '',
                fechaadquisicion: '',
                beneficionproveedor: '',
                agencia: '',
                permiso: '',
            }
            this.dataListCorralon = [];
            this.dataListGrua = [];
            this.dataListOtrasSanciones = [];
            this.dataListMultas = [];
            this.dataListSeguro = [];
            this.dataListTenencias = [];
            this.dataListVerificaciones = [];
            this.items = []
            this.localizador = null

            this.nuevoAuto = true
            this.selectModelo = ''
            this.dialogDetalles = true
            this.id_vehiculo = ''
        },
        async GetAutos() {
            this.loading = true
            try {
                let respuesa = await axios.get('Autos/GetListaAutos/')
                console.log(respuesa.data)
                this.listaCarros = respuesa.data
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async GetAutoXid(item) {
            console.log(item._id)
            try {
                let respuesa = await axios.get('Autos/GetModeloXid/' + item.id_ModeloAnio)
                console.log(respuesa.data)
                return respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async PostAuto() {
            if (this.selectAgencia == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el nombre de la agencia.` });
                return
            }
            if (this.selectModelo == "") {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el modelo del vehiculo a dar de alta.` });
                return
            }
            this.auto.id_proveedor = this.selectAgencia._id
            this.auto.agencia = this.selectAgencia.rfc + ' | ' + this.selectAgencia.razon_social
            this.auto.id_ModeloAnio = this.selectModelo._id
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando Auto. Espere...', messageColor: 'white' })
            try {
                const resp = await axios.post(`Autos/AltaAuto/`, this.auto);
                console.log(resp)
                this.$q.loading.hide()

                if (resp.data.edopet == "0") {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Auto registrado correctamente.` });
                    this.dialogDetalles = false
                    this.GetAutos()
                } else {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al guardar el Auto. Intentelo de nuevo...` });
                }

            } catch (err) {
                console.log(err)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al guardar el Auto. Intentelo de nuevo...` });
            }
        },

        async GetModelos() {
            try {
                let respuesa = await axios.get('Autos/GetListaModelosxMarca/Todos')
                console.log(respuesa)
                this.$store.state.auth.listModelosStore = respuesa.data

            } catch (error) {
                console.log(error)
            }
        },

        async GetProveedores() {
            try {
                let respuesa = await axios.get('Catalogos/GetProveedoresTipo/Agencia')
                console.log(respuesa.data)
                this.listaAgencias = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },

        async GetCxPSeguro() {
            this.dataListSeguro = []
            try {
                let respuesa = await axios.get('CXC/GetCxpIdVTipo/' + this.id_vehiculo + '/Seguro')
                console.log(respuesa)
                this.dataListSeguro = respuesa.data.lista
            } catch (error) {
                console.log(error)
            }
        },
        async GetCxPMultas() {
            this.dataListMultas = []
            try {
                let respuesa = await axios.get('CXC/GetCxpIdVTipo/' + this.id_vehiculo + '/Multas')
                console.log(respuesa)
                this.dataListMultas = respuesa.data.lista
            } catch (error) {
                console.log(error)
            }
        },
        async GetCxPTenencia() {
            this.dataListTenencias = []
            try {
                let respuesa = await axios.get('CXC/GetCxpIdVTipo/' + this.id_vehiculo + '/Tenencia')
                console.log(respuesa)
                this.dataListTenencias = respuesa.data.lista
            } catch (error) {
                console.log(error)
            }
        },
        async GetCxPVerificacion() {
            this.dataListVerificaciones = []
            try {
                let respuesa = await axios.get('CXC/GetCxpIdVTipo/' + this.id_vehiculo + '/Verificación')
                console.log(respuesa)
                this.dataListVerificaciones = respuesa.data.lista
            } catch (error) {
                console.log(error)
            }
        },
        async GetCxPCorralon() {
            this.dataListCorralon = []
            try {
                let respuesa = await axios.get('CXC/GetCxpIdVTipo/' + this.id_vehiculo + '/Corralón')
                console.log(respuesa)
                this.dataListCorralon = respuesa.data.lista
            } catch (error) {
                console.log(error)
            }
        },
        async GetCxPGrua() {
            this.dataListGrua = []
            try {
                let respuesa = await axios.get('CXC/GetCxpIdVTipo/' + this.id_vehiculo + '/Grua')
                console.log(respuesa)
                this.dataListGrua = respuesa.data.lista
            } catch (error) {
                console.log(error)
            }
        },
        async GetCxPOtrasSanciones() {
            this.dataListOtrasSanciones = []
            try {
                let respuesa = await axios.get('CXC/GetCxpIdVTipo/' + this.id_vehiculo + '/OtrasSanciones')
                console.log(respuesa)
                this.dataListOtrasSanciones = respuesa.data.lista
            } catch (error) {
                console.log(error)
            }
        },
        async GetListaSeguros() {
            this.loading = true
            try {
                let respuesa = await axios.get('Autos/GetListaSegurosAutos/' + this.id_vehiculo)
                console.log(respuesa)
                this.items = respuesa.data
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },

        async GetLocalizadorPorAuto() {
            try {
                let respuesa = await axios.get('Autos/GetLocalizadorPorAuto/' + this.id_vehiculo)
                console.log('Localizador', respuesa)
                this.localizador = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },

    }
}
</script>


<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>